import * as React from 'react';
import {DataNodeModel} from './DataNodeModel';
import {AbstractReactFactory} from '@projectstorm/react-canvas-core';
import {DiagramEngine} from '@projectstorm/react-diagrams-core';
import {DataNodeWidget} from "./DataNodeWidget";

interface GenerateCustomModelEvent  {
}

export interface DataNodeFactoryOptions {
    showSidePanel: () => void;
}

export class DataNodeFactory extends AbstractReactFactory<DataNodeModel, DiagramEngine> {
    options: DataNodeFactoryOptions;

    constructor(options: DataNodeFactoryOptions) {
        super('ts-custom-node');
        this.options = options;
    }

    generateModel(initialConfig: GenerateCustomModelEvent) {
        return new DataNodeModel();
    }

    generateReactWidget(event: { model: any; }): JSX.Element {
        return <DataNodeWidget options={this.options} engine={this.engine as DiagramEngine} node={event.model}/>;
    }
}
